import { JSEncrypt } from "jsencrypt";
import SpecificExceptions from "./specific-exceptions";
import GenericExceptions from "./generic-exceptions";
const cem_key = window["CEM_KEY"];
export async function callBackendService(
  url,
  requestBody,
  methodType,
  { ...extraHeader }
) {
  let headers = {
    "Content-Type": "application/json",
    "cem-key": cem_key,
  };

  if (extraHeader) {
    headers = { ...headers, ...extraHeader };
  }

  return new Promise((resolve, reject) => {
    fetch(url, {
      method: methodType,
      body: JSON.stringify(requestBody),
      headers: headers,
    })
      .then(async (res) => res.json())
      .then(async (result) => {
        let responseStatus = {};
        console.log("result:", result);

        if (!url.includes("forget/v1/transaction/verify")) {
          if (url.includes("username") || url.includes("verify/client")) {
            responseStatus.code = result.status.code;
            responseStatus.message = result.status.message;
            responseStatus.arabicDetail = result.status.arabicDetail;
            responseStatus.englishDetail = result.status.englishDetail;
          } else {
            responseStatus.code = result.status.code;
            responseStatus.message = result.status.message;
            responseStatus.arabicDetail = result.status.arabicDetail;
            responseStatus.englishDetail = result.status.englishDetail;
          }
          if (responseStatus && responseStatus.code !== "MAPI-000") {
            if (responseStatus.code === "MAPI-500") {
              if (window.lang === "en") {
                reject(new GenericExceptions(responseStatus.englishDetail));
              } else {
                reject(new GenericExceptions(responseStatus.arabicDetail));
              }
            } else if (responseStatus.code === "MAPI-020") {
              if (window.lang === "en") {
                // ENGLISH LANGUAGE
                reject(
                  new SpecificExceptions(responseStatus.code, "Invalid number")
                );
              } else {
                // ARABIC LANGUAGE
                reject(
                  new SpecificExceptions(responseStatus.code, "الرقم غير صحيح")
                );
              }
            } else if (responseStatus.code === "MAPI-030") {
              if (window.lang === "en") {
                // ENGLISH LANGUAGE
                reject(
                  new SpecificExceptions(
                    responseStatus.code,
                    "Customer service is always here\n\nTo use mobily services and access the portal, please call customer care on 1100 to update your information.\n\n"
                  )
                );
              } else {
                // ARABIC LANGUAGE
                reject(
                  new SpecificExceptions(
                    responseStatus.code,
                    "خدمة العملاء موجودون دائمًا لخدمتك\n\n" +
                      "لاستخدام خدمات موبايلي والدخول إلى البوابة الإلكترونية، يرجى الاتصال بخدمة العملاء 1100 لتحديث معلوماتك\n\n."
                  )
                );
              }

              //reject(responseStatus.message);
            } else if (responseStatus.code === "MAPI-003" && result.userInfo.subadmin === "IS_SUB_ADMIN") {
              reject(
                new SpecificExceptions(
                  responseStatus.code,
                  window.lang === "en" ? "Password update is restricted, kindly contact your corporate authorized person." :
                                          "عذراً، لايمكن تحديث كلمة المرور ، يرجى التواصل مع مفوض منشأتكم"
                )
              );
            } else {
              if (window.lang === "en") {
                // ENGLISH LANGUAGE
                reject(
                  new SpecificExceptions(
                    responseStatus.code,
                    responseStatus.englishDetail
                  )
                );
              } else {
                // ARABIC LANGUAGE
                reject(
                  new SpecificExceptions(
                    responseStatus.code,
                    responseStatus.arabicDetail
                  )
                );
              }
            }
          }
          resolve(result);
        }

        if (url.includes("forget/v1/transaction/verify")) {
          if (result.code === "MAPI-051") {
            if (window.lang === "en") {
              reject(new SpecificExceptions(result.code, result.englishDetail));
            } else {
              reject(new SpecificExceptions(result.code, result.arabicDetail));
            }
          }

          if (result.code === "MAPI-000") {
            resolve(result);
          } else {
            if (window.lang === "en") {
              reject(new SpecificExceptions(result.code, result.englishDetail));
            } else {
              reject(new SpecificExceptions(result.code, result.arabicDetail));
            }
          }
        }
      })
      .catch((err) => {
        reject("Generic error - please try again ...");
        console.log(err);
      });
  });
}

export function encrypt(message) {
  const publicKey = window.PK;
  let RSAEncrypt = new JSEncrypt();
  RSAEncrypt.setPublicKey(publicKey);
  let encryptedMessage = RSAEncrypt.encrypt(message);
  return encryptedMessage;
}

export function reGenerateToken_() {
  return "ab37b334-f6e6-4df4-85b3-bbbf5ceb44bc";
}
export function reGenerateToken() {
  // console.log("reGenerateToken :: Enter");

  let reGenerateToken = window.reGenerateToken;
  // console.log("reGenerateToken => " + reGenerateToken);
  return new Promise((resolve, reject) => {
    fetch(reGenerateToken, {
      method: "POST",
      headers: {
        "Content-type": "text/html; charset=UTF-8",
        "cem-key": cem_key,
      },
    })
      .then((res) => res.text())

      .then((result) => {
        // console.log("Token res -> " + result);
        resolve(result);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
}
